import { Input } from '@/components/ui/input'
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectItem,
  SelectContent,
} from '@/components/ui/select'
import { Control } from 'react-hook-form'
import { FormSchema } from '../sidebar-content'
import { FormField, FormLabel } from '@/components/ui/form'

export function Education({ control }: { control: Control<FormSchema> }) {
  return (
    <>
      <FormField
        control={control}
        name="educational_level"
        render={({ field }) => (
          <>
            <FormLabel>ระดับการศึกษา</FormLabel>
            <Select value={field.value ?? 'ANY'} onValueChange={field.onChange}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="ระดับการศึกษาสูงสุด" />
              </SelectTrigger>
              <SelectContent className="z-[200]">
                <SelectItem value="ANY">ระดับการศึกษา</SelectItem>
                <SelectItem value="PRIMARY">ประถม</SelectItem>
                <SelectItem value="MIDDLE">มัธยมต้น</SelectItem>
                <SelectItem value="HIGH">มัธยมปลาย</SelectItem>
                <SelectItem value="BACHELOR">ปริญญาตรี</SelectItem>
                <SelectItem value="MASTER">ปริญญาโท</SelectItem>
                <SelectItem value="PHD">ปริญญาเอก</SelectItem>
              </SelectContent>
            </Select>
          </>
        )}
      />

      <FormField
        control={control}
        name="class_level"
        render={({ field }) => (
          <div className="flex w-full justify-between gap-2">
            <div className="flex w-1/2 flex-col gap-2">
              <FormLabel>ชั้นปี</FormLabel>
              <Input
                {...field}
                value={field.value ?? ''}
                placeholder="ชั้นปี"
              />
            </div>
          </div>
        )}
      />

      <FormField
        control={control}
        name="school_name"
        render={({ field }) => (
          <>
            <FormLabel>Place of work/study</FormLabel>
            <Input
              {...field}
              value={field.value ?? ''}
              placeholder="สถานที่ทำงานหรือสถานศึกษา"
            />
          </>
        )}
      />
    </>
  )
}
